export enum CmsType {
  INTERNAL = 1,
  EXTERNAL = 2,
  FOOTER = 3,
}

export interface CMSContent {
  cmsPageId: number;
  cmsType: CmsType;
  targetUrl?: string;
  showInMenu: boolean;
  slug?: string;
  authenticatedOnly: boolean;
  title: {
    EN?: string;
    value?: string;
  };
  content: {
    EN?: string;
    value?: string;
  };
}
